import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user: null,
  isAuthenticated: false,
  loading: true,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setUser(state, action) {
      state.user = action.payload;
      state.isAuthenticated = !!action.payload;
      state.loading = false;
    },
    logoutUser(state) {
      state.user = null;
      state.isAuthenticated = false;
      state.loading = false;
    },
    refreshTokenSuccess(state, action) {
      state.user = action.payload;
      state.isAuthenticated = true;
    },
  },
});

export const { setUser, logoutUser, refreshTokenSuccess } = authSlice.actions;
export default authSlice;
